import React from 'react';
import tecno from '../../Tecno-list/tecno';
import { Link } from 'react-router-dom';

function Cinegon() {

    return (
        <React.Fragment>
            <section className='Proyect'>

                <h2 className="">Game Over Web</h2>
                <div className='folder-porfolio'>

                    <iframe src="https://www.youtube.com/embed/OMgYyvn_Rew" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>

                    <div className="list" >

                        {tecno.filter(tec => tec.T === 'Bootstrap' || tec.T === 'Python' || tec.T === 'MySql' || tec.T === 'HTML' || tec.T === 'CSS').map(tec => (

                            <div key={tec.T}>

                                <a href={tec.L} target="_blank" rel="noreferrer">

                                    <button className="etiqueta">  <p> <span>&#183;</span> {tec.T}</p></button>
                                </a>
                            </div>

                        ))}
                    </div>

                    <p className='white'>

                        This website is set to the gaming world, it allows you to create users,
                        profiles and upload posts about your favorite video games.

                    </p>
                            
                    <a href="https://github.com/BrandonGrimaldoM/gameoverweb" target="_blank" rel="noreferrer">
                        <button className="Git"> <p>Repository </p> <div className="gitIcon"></div> </button>
                    </a>
                </div>
                <div className='after'>
                    <Link to="/old-web-pages" className="Link">  <div className='iconAfter'>  <p className='flecha'>←</p></div>  </Link>
                </div>
            </section>
        </React.Fragment>
    );
}
export default Cinegon;